// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"105":"dict","145":"BrowsingHistory","441":"RoleMag","510":"FileResources","805":"UserMag","852":"OperationLog"}[chunkId] || chunkId) + "." + {"105":"942600af","145":"9cf5eef7","346":"cd26556b","441":"95429758","510":"ffb155f8","549":"59f141e5","805":"127ee5a8","852":"c4e2806d"}[chunkId] + ".css";
};